module.exports = __webpack_public_path__ + "img/logo20250613name.8f32e88a.png";